// src/pages/ProfileEdit/insuranceTourConfig.js

export const insuranceTourSteps = [
    {
        popover: {
            title: '👋 Bienvenue sur Assurance & Urgence',
            description: 'Je vais vous guider pour configurer vos informations d\'assurance et vos contacts d\'urgence.',
            side: 'over',
        },
    },
    {
        element: '.pe-side',
        popover: {
            title: '📋 Menu de Navigation',
            description: 'Utilisez ce menu pour naviguer entre les différentes sections de votre profil.',
            position: 'right',
        },
    },
    {
        element: '.pe-item.is-active',
        popover: {
            title: '🏥 Section Active',
            description: 'Vous êtes dans la section Assurance/Urgence où vous pouvez gérer vos assurances santé et contacts d\'urgence.',
            position: 'right',
        },
    },
    {
        element: '.insu-panel',
        popover: {
            title: '📝 Formulaire Assurance & Urgence',
            description: 'Cette page contient deux sections principales : vos assurances médicales et vos contacts d\'urgence.',
            position: 'center',
        },
    },
    {
        element: '.insu-card:first-child',
        popover: {
            title: '🏥 Informations d\'Assurance',
            description: 'Gérez vos différentes assurances médicales. Vous pouvez en avoir plusieurs actives simultanément.',
            position: 'left',
        },
    },
    {
        element: '.insu-card__title',
        popover: {
            title: '📄 Titre de Section',
            description: 'Chaque section est clairement identifiée pour une navigation facile.',
            position: 'bottom',
        },
    },
    {
        element: '.iconbtn',
        popover: {
            title: '➕ Ajouter une Assurance',
            description: 'Cliquez sur ce bouton pour ajouter une nouvelle assurance à votre liste.',
            position: 'left',
        },
    },
    {
        element: '.insu-list',
        popover: {
            title: '📋 Liste des Assurances',
            description: 'Toutes vos assurances disponibles sont listées ici. Activez celles qui vous concernent.',
            position: 'top',
        },
    },
    {
        element: '.insu-row:first-child',
        popover: {
            title: '🏢 Ligne d\'Assurance',
            description: 'Chaque ligne représente une assurance. Cliquez sur le nom pour le modifier, utilisez le toggle pour l\'activer.',
            position: 'right',
        },
    },
    {
        element: '.insu-toggle',
        popover: {
            title: '✅ Activer/Désactiver',
            description: 'Utilisez ce bouton pour activer ou désactiver une assurance. Seules les assurances actives seront enregistrées.',
            position: 'left',
        },
    },
    {
        element: '.insu-card:last-child',
        popover: {
            title: '🚨 Contact Principal',
            description: 'Définissez des contacts de confiance qui seront alertés en cas d\'urgence médicale ou personnelle.',
            position: 'left',
        },
    },
    {
        element: '.insu-help',
        popover: {
            title: '💡 Conseil',
            description: 'Des conseils vous guident pour remplir correctement chaque section.',
            position: 'right',
        },
    },
    {
        element: '.insu-contacts',
        popover: {
            title: '👥 Liste des Contacts',
            description: 'Vos contacts d\'urgence avec leurs informations complètes. Maximum 5 contacts autorisés.',
            position: 'top',
        },
    },
    {
        element: '.insu-contact:first-child',
        popover: {
            title: '👤 Carte de Contact',
            description: 'Chaque carte affiche un contact avec son avatar, nom, relation et numéro de téléphone.',
            position: 'right',
        },
    },
    {
        element: '.insu-contact__avatar',
        popover: {
            title: '🎭 Avatar',
            description: 'L\'avatar est généré automatiquement à partir des initiales du nom du contact.',
            position: 'right',
        },
    },
    {
        element: '.insu-contact__name',
        popover: {
            title: '✏️ Modifier le Contact',
            description: 'Cliquez sur le nom, la relation ou le téléphone pour modifier les informations du contact.',
            position: 'top',
        },
    },
    {
        element: '.insu-iconbtn--danger',
        popover: {
            title: '🗑️ Supprimer',
            description: 'Cliquez sur l\'icône de poubelle pour supprimer un contact de la liste.',
            position: 'left',
        },
    },
    {
        element: '.insu-addcard',
        popover: {
            title: '➕ Ajouter un Contact',
            description: 'Cliquez ici pour ajouter un nouveau contact d\'urgence. Vous pouvez en avoir jusqu\'à 5.',
            position: 'top',
        },
    },
    {
        element: '.pe-footer',
        popover: {
            title: '💾 Sauvegarder',
            description: 'N\'oubliez pas de sauvegarder vos modifications avant de quitter la page.',
            position: 'top',
        },
    },
    {
        element: '.pe-save',
        popover: {
            title: '✅ Enregistrer les Modifications',
            description: 'Cliquez sur "Save changes" pour enregistrer toutes vos modifications d\'assurance et de contacts.',
            position: 'top',
        },
    },
    {
        popover: {
            title: '🎉 Tour Terminé !',
            description: 'Vous savez maintenant comment gérer vos assurances et contacts d\'urgence. Gardez ces informations à jour pour votre sécurité !',
            side: 'over',
        },
    },
];